import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { DATA_LOOKUP_LEVEL_ACTION_TYPE, DataLookUpLevelAction } from "./data-lookup-level.action";
import { DataLookUpPayload, DataLookUpResponse } from "./data-lookup-level.model";
import { DataLookupLevelService } from "./data-lookup-level.service";

@Injectable()
export class DataLookUpLevelEffect {
	getDataLookupLevel$ = createEffect(() =>
		this.actions$.pipe(
			ofType(DATA_LOOKUP_LEVEL_ACTION_TYPE.getDataLookupLevel),
			map((x: ActionWithPayload<DataLookUpPayload>) => x.payload),
			switchMap((request) =>
				this.dataLookupLevelService.getDataLookupLevel(request.transactionId).pipe(
					map((response: DataLookUpResponse) => this.action.dataLookUpLevelSuccess(response)),
					catchError((response: AppError) => of(this.action.dataLookUpLevelFail(response)))
				)
			)
		)
	);

	resetDataLookupLevel$ = createEffect(() =>
		this.actions$.pipe(
			ofType(
				DATA_LOOKUP_LEVEL_ACTION_TYPE.getDataLookupLevelSuccess,
				DATA_LOOKUP_LEVEL_ACTION_TYPE.getDataLookupLevelFail
			),
			map(() => this.action.resetState())
		)
	);

	constructor(
		private actions$: Actions,
		private action: DataLookUpLevelAction,
		private dataLookupLevelService: DataLookupLevelService
	) {}
}
